/* istanbul ignore file */
import { FC, Fragment, useEffect, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';

import {
  fetchTranslation,
  localizationSelector
} from 'store/localizationState';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getMarketSettings } from 'utils/marketSettingUtils';

import Router from 'router';
import Loader from 'components/UI/Loader';
import PageWrapper from 'components/UI/Page/PageWrapper';
import ErrorDisplay from 'components/fragments/ErrorDisplay';

import { GlobalStyles } from 'styles';
import { husqvarnaTheme, constructionTheme } from 'styles/themes';
import { isConstruction } from 'config';

const App: FC = () => {
  const dispatch = useAppDispatch();
  const { isLoadingTranslation } = useAppSelector(localizationSelector);

  // Fetch market settings
  useEffect(() => {
    const { languageCode, languageRegionCode } = getMarketSettings();
    dispatch(fetchTranslation(languageCode, languageRegionCode));
  }, [dispatch]);

  const content = useMemo(() => {
    if (isLoadingTranslation) {
      return (
        <PageWrapper empty>
          <Loader center size="large" />
        </PageWrapper>
      );
    }

    return (
      <Fragment>
        <Router />
        <ErrorDisplay />
      </Fragment>
    );
  }, [isLoadingTranslation]);

  return (
    <ThemeProvider theme={isConstruction ? constructionTheme : husqvarnaTheme}>
      <GlobalStyles />
      {content}
    </ThemeProvider>
  );
};

export default App;
